/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type IngredientsSummaryList_summaryIngredient$ref: FragmentReference;
declare export opaque type IngredientsSummaryList_summaryIngredient$fragmentType: IngredientsSummaryList_summaryIngredient$ref;
export type IngredientsSummaryList_summaryIngredient = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +ingredient: {|
        +name: string
      |}
    |}
  |}>,
  +$refType: IngredientsSummaryList_summaryIngredient$ref,
|};
export type IngredientsSummaryList_summaryIngredient$data = IngredientsSummaryList_summaryIngredient;
export type IngredientsSummaryList_summaryIngredient$key = {
  +$data?: IngredientsSummaryList_summaryIngredient$data,
  +$fragmentRefs: IngredientsSummaryList_summaryIngredient$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IngredientsSummaryList_summaryIngredient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeIngredientNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeIngredientNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IngredientNode",
              "kind": "LinkedField",
              "name": "ingredient",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecipeIngredientNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '6e51dfebad991967e540ba8d2b8f1396';

module.exports = node;
